var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailBlueSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "svx5a",
    d: "M922.157 213.59a1.644 1.644 0 0 1-1.179.495c-.447 0-.867-.177-1.182-.497l-9.719-9.829c-.05.156-.077.334-.077.536v13.421c0 .88.406 1.29 1.278 1.29h19.444c.86 0 1.278-.423 1.278-1.29v-13.421c0-.214-.03-.403-.086-.565z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svx5b",
    d: "M920.506 212.881a.655.655 0 0 0 .938.001l9.722-9.825a1.743 1.743 0 0 0-.446-.057h-19.444c-.178 0-.335.025-.476.065z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-910 -203)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#svx5a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#svx5b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBlueSmall);
export default __webpack_public_path__ + "static/media/email-blue-small.daafdbc7c4a2fd03e94a6c80ca83b811.svg";
export { ForwardRef as ReactComponent };